/**
 * Created by Jerker Nord on 2021-06-17.
 */

export enum SimpleReelModelState {
    IDLE = "IDLE",
    START = "START",
    SPIN = "SPIN",
    STOP = "STOP",
    STOPPED = "STOPPED",
    BOUNCE = "BOUNCE",
    NUDGE = "NUDGE",
}

export interface ISymbol {
    symbolName:string,
    reelPosition:number,
    reelTargetPosition:number,
    reelId:number
    position:PIXI.Point,
    isRemoved:boolean,
    splitLevel:number,
    transformed:boolean
}

export interface ISymbolPosition {
    reelId:number,
    startPosition:number,
    targetPosition:number
}

export interface SimpleReelModelEventData {
    reel:number;
    state:SimpleReelModelState;
}


export interface SimpleReelPaddingData {
    visualPaddingBefore:number;
    paddingBefore:number;
    visibleSymbols:number;
    paddingAfter:number;
    visualPaddingAfter:number;
}
